"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function each(obj, fn, context) {
    if (!obj || !(typeof fn === 'function')) {
        return;
    }
    context = context || obj;
    if (Array.isArray(obj)) {
        for (var i = 0, l = obj.length; i < l; i++) {
            if (fn.call(context, obj[i], i, obj) === false) {
                return;
            }
        }
    }
    else if (typeof obj === 'object') {
        for (var n in obj) {
            if (fn.call(context, obj[n], n, obj) === false) {
                return;
            }
        }
    }
}
exports.each = each;
var camelizeRE = /_(\w)/g;
exports.jsonREG = /^[\{\[][\w\W]*[\}\]]$/;
function camelize(str) {
    return str.replace(camelizeRE, toUpper);
}
exports.camelize = camelize;
function toUpper(_, c) {
    return c ? c.toUpperCase() : '';
}
function noop() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
}
exports.noop = noop;
function createFrame(src, id) {
    var frame = document.createElement('IFRAME');
    frame.id = id;
    frame.style.display = 'none';
    frame.src = src;
    document.body.appendChild(frame);
    return frame;
}
exports.createFrame = createFrame;
function randomId(len) {
    if (len === void 0) { len = 8; }
    return parseInt(Math.random() * Math.pow(10, len) + '');
}
exports.randomId = randomId;
function arrayIndexOf(arr, item) {
    return arr.some(function (t) {
        return t === item;
    });
}
exports.arrayIndexOf = arrayIndexOf;
